import { Component } from '@angular/core';
import { BaseModalDirective } from '../base-modal';

@Component({
    selector: 'nh-confirm-appeal-auth-ack',
    templateUrl: './confirm-appeal-auth-ack.component.html',
    styleUrls: ['./confirm-appeal-auth-ack.component.scss'],
    standalone: false
})
export class ConfirmFileAppealAuthAckComponent extends BaseModalDirective {
  isConfirmDisabled(): boolean {
    return false;
  }
}
